<template>
    <LayoutBase>
        <div class="container">
            <div class="panel app-position">
                <form class="form">
                    <div class="form__group">
                        <label class="form__label" for="name" id="">Name this group</label>
                        <input type="text" name="name" v-model="group.name" maxlength="100" placeholder="" class="form__control" autocomplete="off">
                    </div>
                    <div class="form__group" v-if="!group.slug">
                        <label class="form__label" for="description">Section type</label>
                        <div class="select">
                            <select name="description" class="form__control" v-model="group.type">
                                <option value="1">Chronological (used for news, blogs, updates etc)</option>
                                <option value="2">Knowledge Base (used for processes, guides, information)</option>
                                <option value="3">Files</option>
                                <option value="4">Events</option>
                                <option value="5">Forum</option>
                            </select>
                        </div>
                    </div>
                    <div class="form__group">
                        <label class="form__label" for="description">Who can view this group?</label>
                        <div class="select">
                            <select name="description" class="form__control" v-model="group.private">
                                <option value="0">Anyone in your team can view posts in this group</option>
                                <option value="1">Only members of this group can view its posts</option>
                            </select>
                        </div>
                    </div>
                    <div class="form__group" v-if="group.private == '1'">
                        <label class="form__label">Add people to this group</label>
                        <ul class="authors">
                            <li class="add-author">
                                <search-dialog 
                                    :id="'group-member-modal'" 
                                    :users="group.members" 
                                    :buttonText="'Add to group'" 
                                    :buttonTextComplete="'Added to group'" 
                                    v-on:group-member-modal-add-item="addMember">
                                </search-dialog>
                                <a href="#" v-on:click.stop.prevent="openModal('group-member-modal')" class="avatar avatar-add">
                                    <i class="icon ion-md-person-add"></i>
                                </a>
                            </li>
                            <li v-for="user in group.members">
                                <avatar :user="user" :deletable="true" v-on:remove-user="removeMember"></avatar>
                            </li>
                        </ul>
                    </div>
                    <div class="form__group">
                        <label class="form__label" for="description">Who can create posts?</label>
                        <div class="select">
                            <select name="description" class="form__control" v-model="group.all_users_can_create_posts">
                                <option value="1">Anyone who can view this group can create posts</option>
                                <option value="0">Only selected users can create posts</option>
                            </select>
                        </div>
                    </div>
                    <div class="form__group" v-if="group.all_users_can_create_posts == '0'">
                        <label class="form__label">Add people who can create posts in this group</label>
                        <ul class="authors">
                            <li class="add-author">
                                <search-dialog 
                                    :id="'group-creator-modal'" 
                                    :users="group.creators" 
                                    :buttonText="'Add to group'" 
                                    :buttonTextComplete="'Added to group'" 
                                    v-on:group-creator-modal-add-item="addCreator">
                                </search-dialog>
                                <a href="#" v-on:click.stop.prevent="openModal('group-creator-modal')" class="avatar avatar-add">
                                    <i class="icon ion-md-person-add"></i>
                                </a>
                            </li>
                            <li v-for="user in group.creators">
                                <avatar :user="user" :deletable="true" v-on:remove-user="removeCreator"></avatar>
                            </li>
                        </ul>
                    </div>
                    <div class="form__group">
                        <label class="form__label">Add group administrators</label>
                        <small>Group administrators can view/edit/delete any post, create/delete categories and edit posts. Any Team administrator can already do this and doesn't need to be added.</small>
                        <ul class="authors">
                            <li class="add-author">
                                <search-dialog 
                                    :id="'group-admin-modal'" 
                                    :users="group.admins" 
                                    :buttonText="'Add to group'" 
                                    :buttonTextComplete="'Added to group'" 
                                    v-on:group-admin-modal-add-item="addAdmin">
                                </search-dialog>
                                <a href="#" v-on:click.stop.prevent="openModal('group-admin-modal')" class="avatar avatar-add">
                                    <i class="icon ion-md-person-add"></i>
                                </a>
                            </li>
                            <li v-for="user in group.admins">
                                <avatar :user="user" :deletable="true" v-on:remove-user="removeAdmin"></avatar>
                            </li>
                        </ul>
                    </div>


                    <div class="form__group">
                        <button type="submit" class="btn btn-primary" v-on:click.stop.prevent="saveGroup" v-if="!group.slug">Create group</button>
                        <button type="submit" class="btn btn-primary" v-on:click.stop.prevent="saveGroup" v-if="group.slug">Edit group</button>
                    </div>
                </form>
            </div>

            <div class="panel" v-if="group.slug">
                <h3>Delete this group</h3>
                <p>Delete this group and all of its posts. This is irreversible.</p>
                <button class="btn btn-danger" v-on:click.stop.prevent="openModal('delete-post')">Delete group</button>

                <div class="modal micromodal-slide" id="delete-post" aria-hidden="true">
                    <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-post-settings-title">
                            <div class="modal__content" id="modal-new-category-content">
                                <h3>Delete group "{{ group.name }}"</h3>
                                <p>Are you sure you wish to delete the group "{{ group.name }}"?</p>
                            </div>
                            <footer class="modal__footer">
                                <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                <button class="btn btn-danger" v-on:click.stop.prevent="deleteGroup(group.id)">Delete</button>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';
    import MicroModal from 'micromodal';

    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                editGroupURL: '/api/groups/' + this.$route.params.group,
                createGroupURL: '/api/groups',
                group: {
                    type: 1,
                    private: "0",
                    all_users_can_create_posts: "1",
                    members: [],
                    creators: [],
                    admins: [],
                },
            }
        },
        created() {
            if (this.$route.params.group) {
                this.getGroup();
            }
        },
        methods: {
            getGroup() {
                axios.get( '/api/groups/' + this.$route.params.group ).then((response) => {
                    this.group = response.data;
                }, (response) => {
                    this.error = response;
                });
            },
            openModal(modal){
                MicroModal.show(modal);
            },
            addMember(user){
                this.group.members.push(user);
            },
            removeMember(memberID){
                this.group.members = this.group.members.filter(function( obj ) {
                    return obj.id !== memberID;
                });
            },
            addCreator(user){
                this.group.creators.push(user);
            },
            addAdmin(user){
                this.group.admins.push(user);
            },
            removeCreator(creatorID){
                this.group.creators = this.group.creators.filter(function( obj ) {
                    return obj.id !== creatorID;
                });
            },
            removeAuthor(authorID){
                this.group.authors = this.group.authors.filter(function( obj ) {
                    return obj.id !== authorID;
                });
            },
            removeAdmin(adminID){
                this.group.admins = this.group.admins.filter(function( obj ) {
                    return obj.id !== adminID;
                });
            },
            saveGroup(){
                if(this.group.slug){
                    axios.put(this.editGroupURL, this.group).then((response) => {
                        this.group = response.data;
                        if(window.sessionStorage){
                            sessionStorage.removeItem('group:' + this.$route.params.group);
                            sessionStorage.removeItem('group:' + this.$route.params.group + ":expires");
                        }
                        this.$router.push({ name: 'view-group', params: { group: this.group.slug } });
                    }, (response) => {
                        this.error = response;
                    });
                }else{
                    axios.post(this.createGroupURL, this.group).then((response) => {
                        this.group = response.data;
                        if(window.sessionStorage){
                            sessionStorage.removeItem('group:' + this.$route.params.group);
                            sessionStorage.removeItem('group:' + this.$route.params.group + ":expires");
                        }
                        this.$router.push({ name: 'view-group', params: { group: this.group.slug } });
                    }, (response) => {
                        this.error = response;
                    });
                }
            },
            deleteGroup(group_id){
                axios.delete(this.editGroupURL, this.group).then((response) => {
                    this.$router.push({ name: 'groups' });
                }, (response) => {
                    this.error = response;
                });
            }
        }
    }
</script>

<style lang="scss">
    
</style>